// The four claims the brand panel makes, shared by every auth surface.
//
// This lived twice — once in AuthShell.jsx and once in RequestAccessPage.jsx —
// under a comment in each saying the two were "reused verbatim so the promise
// stays identical everywhere". They were not: the alerts line had drifted to
// "across every district" on the request-access page while the login said
// "across every sector", and a copy change to one surface would have left the
// other behind. One array, imported by both, is the only way that comment is
// true. Headings and subtitles stay per-surface — those legitimately differ.
//
// Order is deliberate, not incidental. The climate-health claim leads because
// it is the stronger one: real-time alerts are what any surveillance tool
// promises, the link to climate is what this one adds (team call, 03 Sep 2026).
// "relationship", not "correlation" — correlation is a specific statistical
// claim, and we don't publish a coefficient to back it on a login page.
// 416 is the sector count in the NISR ADM3 boundary set the maps render, so
// this string and frontend/public/geojson/rwanda-adm3-nisr.geojson move
// together; it is asserted against that file in authBrandCopy.test.mjs.
// The forecast claim is SECOND by client instruction, not by editorial taste
// (Ministry via Blaise, 04 Sep 2026: "please add also this as the 2nd point:
// Diseases incidences forecasts for every sector based on seasonal climate
// forecasts and other environmental factors"). Compressed to bullet length —
// the panel's labels run 42-51 chars and this column is 42% of the viewport.
// "for every sector" is dropped because the two neighbouring claims already
// say 416 sectors and "every sector"; a third is noise, not scope. The claim
// itself is backed: services/model-intelligence/utils/rsaForecastImport.js
// ingests RSA's sector-level forecasts for malaria, flu, pneumonia, diarrhea.
import { CloudSun, Radio, TrendingUp, ShieldCheck } from 'lucide-react'

export const AUTH_BRAND_ITEMS = [
  { icon: TrendingUp, label: 'Climate-health relationship in 416 sectors' },
  { icon: CloudSun, label: 'Diseases incidences forecasts for every sector based on seasonal climate forecasts and other environmental factors' },
  { icon: Radio, label: 'Real-time outbreak alerts across every sector' },
  { icon: ShieldCheck, label: "Role-based access built for Rwanda's health network" },
]
